import { MASK_RESERVER_CHAR } from '@ui/utils/masks'

export const CLEAN_INPUT_REGEX = /\s/g

export const formatWithMask = (
  input: string,
  template: string,
  targetChar = MASK_RESERVER_CHAR
) => {
  const cleanInput = input.replace(CLEAN_INPUT_REGEX, '')
  const output: string[] = []
  let inputIndex = 0
  for (let i = 0; i < template.length; i++) {
    if (template[i] === targetChar) {
      if (inputIndex < cleanInput.length) {
        output.push(cleanInput[inputIndex])
        inputIndex++
      } else {
        break // Stop rendering mask after last entered char
      }
    } else {
      if (inputIndex > 0 || output.length > 0) {
        output.push(template[i])
      }
    }
  }
  // If input is longer than mask, append the rest
  if (inputIndex < cleanInput.length) {
    output.push(cleanInput.slice(inputIndex))
  }
  return output.join('')
}
